/**
 * TikTok Pixel helpers for the EmbroideryTrace web funnel.
 *
 * The base Pixel queue is installed by public/index.html. These wrappers are
 * intentionally no-ops when that queue is unavailable (SvgTrace builds,
 * native contexts, ad blockers, or test environments).
 */

const TIKTOK_CLICK_ID_KEY = "tiktokClickId";

function ttq() {
  if (typeof window === "undefined") return null;
  return window.ttq && typeof window.ttq.track === "function" ? window.ttq : null;
}

/**
 * Track a TikTok standard event and attach an event_id for browser/server
 * deduplication when the same conversion is also sent through Events API.
 */
export function trackTikTokEvent(eventName, properties = {}, eventId = null) {
  const queue = ttq();
  if (!queue) return null;

  if (eventId) {
    queue.track(eventName, properties, { event_id: eventId });
  } else {
    queue.track(eventName, properties);
  }
  return eventId;
}

/** Fire TikTok's Page event for client-side route changes. */
export function trackTikTokPageView() {
  const queue = ttq();
  if (!queue || typeof queue.page !== "function") return;
  queue.page();
}

/**
 * Capture TikTok attribution identifiers before the Stripe redirect. The
 * values are carried in Stripe metadata so a paid invoice can be attributed
 * by the server even when it arrives after a free trial.
 */
export function getTikTokMatchData() {
  if (typeof window === "undefined" || typeof document === "undefined") return {};

  const readCookie = (name) => {
    const match = document.cookie.match(new RegExp(`(^|;\\s*)${name}=([^;]*)`));
    return match ? decodeURIComponent(match[2]) : undefined;
  };

  const params = new URLSearchParams(window.location.search);
  const incomingClickId = params.get("ttclid");
  if (incomingClickId) {
    localStorage.setItem(TIKTOK_CLICK_ID_KEY, incomingClickId);
  }

  const clamp = (value) => (value ? String(value).slice(0, 500) : undefined);

  return {
    ttp: readCookie("_ttp"),
    ttclid: clamp(incomingClickId || localStorage.getItem(TIKTOK_CLICK_ID_KEY)),
    tiktokUserAgent: clamp(navigator.userAgent),
    tiktokSourceUrl: clamp(window.location.href),
  };
}
